import { useState } from 'react';

type TypeUseToggleProps = {
  /**
   * 초기 상태
   * @default false
   */
  initialState?: boolean;
};

/**
 * 토글 상태 관리 훅
 */
const useToggle = ({ initialState = false }: TypeUseToggleProps = {}) => {
  const [isToggle, setIsToggle] = useState(initialState);

  const handleToggle = () => {
    setIsToggle((prev) => !prev);
  };

  return { isToggle, handleToggle };
};

export default useToggle;
